import type { HelpFile } from '../../types/help'
import { CreateFunctionGroupTestIds } from '../../../testids/CreateFunctionGroupTestIds'

export const createFunctionGroupHelp: HelpFile = {
  docPage: '/docs/governance/function-groups',
  texts: {
    [CreateFunctionGroupTestIds.cardTitleCreateFunctionGroup]:
      'Neue Funktionsgruppe vom festgelegten Typ anlegen. Pflichtattribute leiten sich aus den Attributdefinitionen des Typs ab.',
    [CreateFunctionGroupTestIds.btnCancelCreateFunctionGroup]: null,
    [CreateFunctionGroupTestIds.btnSubmitCreateFunctionGroup]: null,
    [CreateFunctionGroupTestIds.inputFgDescription]: null,
    [CreateFunctionGroupTestIds.selectFgType]: null,
  },
}
